import {Model} from './model.class';
import {Service} from './service.class';
import {Observable} from 'rxjs';
import {ModelService} from './model.service';
import {Response} from '@angular/http';
import ProjectionInformation = Model.ProjectionInformation;

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
export class UserModelService<T extends Model<T>> {

    private _modelService: ModelService<T>;
    changes$: Observable<boolean>;

    constructor(svcm: Service.InjectedMembers, readonly namespace: string, modelType: Model.Type<T>) {
        this._modelService = new ModelService(svcm, namespace, modelType, 'currentUser');
        this.changes$ = this._modelService.changes$;
    }

    doesCurrentUserModelExist(): Observable<boolean> {
        return this._modelService.doesModelEntryExist();
    }

    getCurrentUserModel(projection?: ProjectionInformation): Observable<T> {
        return this._modelService.getModelEntry(projection);
    }

    updateCurrentUserModel(model: T, projection?: ProjectionInformation): Observable<Response> {
        return this._modelService.updateModelEntry(model, projection);
    }

    deleteCurrentUserModel(): Observable<Response> {
        return this._modelService.deleteModelEntry();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/common/user-model.service.ts